const getCurrentUrl = () => window.location.href;

export default getCurrentUrl;
